import { changeEmailRestriction } from '@shop/frontend/web/js/api/rest/email-restriction';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import emailRestrictionSuccessMsgTemplate from '@shop/frontend/web/js/templates/emailRestrictionSuccessMsgTemplate';

function appendSuccessMsg() {
  const header = $('header');

  if (!header.length) return;

  const successMsg = emailRestrictionSuccessMsgTemplate(
    translator.t('main', 'Email has been successfully updated'),
  );

  header.append(successMsg);

  setTimeout(() => {
    successMsg.fadeOut(300, function () {
      $(this).remove();
    });
  }, 5000);
}

export function emailRestriction() {
  const params = new URLSearchParams(window.location.search);

  if (params.get('isEmailChanged')) {
    appendSuccessMsg();
  }

  const form = $('.email-restriction__form');

  if (!form.length) return;

  const title = $('.email-restriction__title');
  const desc = $('.email-restriction__desc');
  const icon = $('.email-restriction__icon');
  const errorText = $('.email-restriction__error-desc');
  const input = form.find('.email-restriction__input');
  const submitBtn = form.find('.email-restriction__btn');

  input.on('input', function () {
    submitBtn.prop('disabled', false);
    errorText.text('');
    input.removeClass('error');
  });

  form.on('submit', function (e) {
    e.preventDefault();

    const inputValue = input.val();
    const email = inputValue ? inputValue.trim() : '';

    if (!email) {
      return;
    }

    submitBtn.prop('disabled', true);

    changeEmailRestriction(email)
      .then(function () {
        title.text(
          translator.t('main', 'Your email has been updated successfully'),
        );

        desc.text(
          translator.t(
            'main',
            'An email with a confirmation link has been sent to the email address you provided. Click it to complete the email change. If you havent received the email, check your Spam folder',
          ),
        );

        icon.addClass('email-restriction__icon_success');
        icon.find('use').attr('xlink:href', '#email-restriction-success');
        submitBtn.hide();
        input.hide();
      })
      .catch(function (err) {
        let error = translator.t('main', 'Error');

        if (err && err.newEmail && err.newEmail.length) {
          error = err.newEmail[0];
        }

        errorText.text(error);
        input.addClass('error');
        submitBtn.prop('disabled', true);
      });
  });
}